// extracted by mini-css-extract-plugin
export default {"eContainer":"EAuthor_eContainer__7reLP","eWrapper":"EAuthor_eWrapper__8S2v7","eText":"EAuthor_eText__Cbq-F","eImg":"EAuthor_eImg__PPkv7"};